/** @format */

import { api } from "./api";

interface hwbMeta {
  name: string;
  sub: string;
  given_name: string;
  family_name: string;
  picture: string;
  email: string;
}

interface userMeta {
  name: string;
  lastLogin: string;
  avatar: string;
  uuid: string;
  hwb?: hwbMeta;
}

// This is copied from the type RS uses
export type UserRole =
  | ""
  | "public"
  | "unknown"
  | "teacher"
  | "wjec"
  | "admin";

export interface UserResponse {
  role: UserRole;
  meta: userMeta;
  wjec: boolean;
  created: string;
  SK: string;
  PK: string;
  email: string;
  modified: string;
  emailHash: string;
}

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUser: build.query<UserResponse, void>({
      query: () => "user/get",
      // transformResponse(res: userResponse, meta, arg){
      //     return res.meta
      // },
      providesTags: ["User"],
    }),
  }),
});

export const { useGetUserQuery } = userApi;
